import { AuthComponent } from "./auth.component";
import { Routes, RouterModule } from "@angular/router";
import { AuthGuardLogin } from "../guards/auth.guard";
import { ModuleWithProviders } from "@angular/core";
import { AdminActivationComponent } from "./login/admin-activation/admin-activation.component";
/**
 * Created by CH-E01327 on 13-04-2017.
 */

export const routes: Routes = [
  {
    path: "auth",
    component: AuthComponent,
    children: [
      { path: "", redirectTo: "/auth/login", pathMatch: "full" },
      {
        path: "login",
        loadChildren: "app/auth/login/login.module#LoginModule",
        data: { title: "Login" },
      },
      {
        path: "register",
        loadChildren: "app/auth/register/register.module#RegisterModule",
        data: { title: "Register" },
      },
    ],
  },
];

export const routing: ModuleWithProviders = RouterModule.forChild(routes);



// WEBPACK FOOTER //
// /Users/ldt/Desktop/afropay_admin/afropay-admin-frontend/src/app/auth/auth.routing.ts